import React, { useState } from "react";
import {
    generateHiddenColumns
} from '../../Utils/Common';
import Table, { renderCellExpand } from '../../components/Table/Table';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import HtmlTooltip from "../../components/HtmlToolTip/HtmlToolTip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

const ingestionJobStatusSchemaView = require("../../json/ingestionJobStatusSchema.json").view;

const uiSchema = {
    "metadataFiles": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "invalidDocumentPaths": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "failedCreatedDocumentPaths": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "failedUploadedDocumentPaths": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "trkFiles": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "internalTrakingFiles": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "emails": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    }
};

const IngestionJobDialog = ({ open, onClose, data }) => {

    const [rowJsonData, setRowJsonData] = useState({});
    const [openView, setOpenView] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode

    // need to add id for mui datagrid table
    let jobData = data.map((object, index) => {
        return { ...object, id: index + 1 };
    });

    const columns = [
        {
            field: 'id',
            type: 'number',
            headerName: 'ID',
            hide: true,
            minWidth: 50,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'jobId',
            headerName: 'Job ID',
            minWidth: 300,
            maxWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'batchId',
            headerName: 'Batch ID',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'startTime',
            headerName: 'Start Time',
            minWidth: 275,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                let formattedStartTime = "";
                if (params.value > 0) {
                    formattedStartTime = new Date(params.value).toISOString();
                }
                return formattedStartTime;
            },
            valueParser: (value) => {
                const date = new Date(value);
                return date.getTime();
            }
        },
        {
            field: 'finishTime',
            headerName: 'Finish Time',
            minWidth: 275,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                let formattedFinishTime = "";
                if (params.value > 0) {
                    formattedFinishTime = new Date(params.value).toISOString();
                }
                return formattedFinishTime;
            },
            valueParser: (value) => {
                const date = new Date(value);
                return date.getTime();
            }
        },
        {
            field: 'totalSizeKB',
            headerName: 'Total Size (KB)',
            minWidth: 125,
            maxWidth: 125,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'documentFailurePaths',
            headerName: 'Document Failure Paths',
            minWidth: 350,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>

                        {params.row.invalidDocumentPaths &&
                                params.row.invalidDocumentPaths.length >= 1 &&
                                <>&nbsp;<strong>Invalid Document Paths: </strong><br />

                                    {params.row.invalidDocumentPaths.map((item) => {
                                        return (
                                            <>
                                                &nbsp;&nbsp;{item}<br />
                                            </>
                                        );
                                    })}
                                </>
                            }

                            {params.row.failedCreatedDocumentPaths &&
                                params.row.failedCreatedDocumentPaths.length >= 1 &&
                                <>&nbsp;<strong>Failed Created Paths: </strong><br />

                                    {params.row.failedCreatedDocumentPaths.map((item) => {
                                        return (
                                            <>
                                                &nbsp;&nbsp;{item}<br />
                                            </>
                                        );
                                    })}
                                </>
                            }

                            {params.row.failedUploadedDocumentPaths &&
                                params.row.failedUploadedDocumentPaths.length >= 1 &&
                                <>&nbsp;<strong>Failed Upload Document Paths: </strong><br />

                                    {params.row.failedUploadedDocumentPaths.map((item) => {
                                        return (
                                            <>
                                                &nbsp;&nbsp;{item}<br />
                                            </>
                                        );
                                    })}
                                </>
                            }
                    </div>
                );
            }
        },
        {
            field: 'metadataFiles',
            headerName: 'Metadata Files',
            minWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
               
                return (
                    <>
                        {params.row.metadataFiles && params.row.metadataFiles.length >= 1 && (
                            <div style={{ flexDirection: 'column', display: 'inline-block' }}>
                                <table border='1' style={{ borderCollapse: 'collapse', width: '300px' }}>
                                    <tr>
                                        <th style={{ textAlign: 'left' }}>Metadata File Path</th>
                                    </tr>
                                    {params.row.metadataFiles && params.row.metadataFiles.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td style={{ padding: '2px', wordBreak: 'break-word' }}>
                                                    {item}
                                                </td>
                                            </tr>
                                        );
                                    })
                                    }
                                </table>
                            </div>
                        )}
                    </>
                );
            }
        },
        {
            field: 'trkFiles',
            headerName: 'TRKFiles',
            minWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
               
                return (
                    <>
                        {params.row.trkFiles && params.row.trkFiles.length >= 1 && (
                            <div>
                                <p>
                                    <HtmlTooltip followCursor placement="top" title={
                                        <>
                                            <h4 style={{ backgroundColor: '#E5E4E2' }}>Tracking Files Values</h4>
                                            <table border='1' style={{ borderCollapse: 'collapse', width: '450px' }}>
                                                <tr>
                                                    <th style={{ textAlign: 'left' }}>FilePath</th>
                                                    <th style={{ textAlign: 'left' }}>Created Date</th>
                                                </tr>
                                                {params.row.trkFiles && params.row.trkFiles.map((trkFiles, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {trkFiles.filePath}
                                                            </td>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {trkFiles.createdDate}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </table>
                                        </>
                                    }>
                                        <div style={{ flexDirection: 'column', display: 'inline-block' }}>
                                            <table border='1' style={{ borderCollapse: 'collapse', width: '150px' }}>
                                                <tr>
                                                    <th style={{ textAlign: 'left' }}>FilePath</th>
                                                </tr>
                                                {params.row.trkFiles && params.row.trkFiles.map((trkFiles, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {trkFiles.filePath}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                }
                                            </table>
                                        </div>

                                    </HtmlTooltip>

                                </p>
                            </div>

                        )}
                    </>
                );
            }
        },
        {
            field: 'internalTrakingFiles',
            headerName: 'Internal Tracking Files',
            minWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
               
                return (
                    <>
                        {params.row.internalTrakingFiles && params.row.internalTrakingFiles.length >= 1 && (
                            <div>
                                <p>
                                    <HtmlTooltip followCursor placement="top" title={
                                        <>
                                            <h4 style={{ backgroundColor: '#E5E4E2' }}>Internal Tracking Files Values</h4>
                                            <table border='1' style={{ borderCollapse: 'collapse', width: '450px' }}>
                                                <tr>
                                                    <th style={{ textAlign: 'left' }}>FilePath</th>
                                                    <th style={{ textAlign: 'left' }}>Created Date</th>
                                                </tr>
                                                {params.row.internalTrakingFiles && params.row.internalTrakingFiles.map((intTrkFiles, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {intTrkFiles.filePath}
                                                            </td>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {intTrkFiles.createdDate}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </table>
                                        </>
                                    }>
                                        <div style={{ flexDirection: 'column', display: 'inline-block' }}>
                                            {params.row.internalTrakingFiles && params.row.internalTrakingFiles.map((intTrkFiles, index) => {
                                                return (
                                                    <>{intTrkFiles.filePath}<br /></>
                                                );
                                            })
                                            }
                                        </div>

                                    </HtmlTooltip>

                                </p>
                            </div>

                        )}
                    </>
                );
            }
        },
        {
            field: 'emails',
            headerName: 'Emails',
            minWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <>
                        {params.row.emails && params.row.emails.length >= 1 && (
                            <div>
                                <p>
                                    <HtmlTooltip followCursor placement="top" title={
                                        <>
                                            <h4 style={{ backgroundColor: '#E5E4E2' }}>Email Values</h4>
                                            <table border='1' style={{ borderCollapse: 'collapse', width: '450px' }}>
                                                <tr>
                                                    <th style={{ textAlign: 'left' }}>Recipents</th>
                                                    <th style={{ textAlign: 'left' }}>Sent Date</th>
                                                </tr>
                                                {params.row.emails && params.row.emails.map((emailData, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {emailData.recipents}
                                                            </td>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {emailData.sentDate}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </table>
                                        </>
                                    }>

                                        <div style={{ flexDirection: 'column', display: 'inline-block' }}>
                                            <table border='1' style={{ borderCollapse: 'collapse', width: '150px' }}>
                                                <tr>
                                                    <th style={{ textAlign: 'left' }}>Recipents</th>
                                                </tr>
                                                {params.row.emails && params.row.emails.map((emailData, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td nowrap style={{ padding: '2px' }}>
                                                                {emailData.recipents}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                }
                                            </table>
                                        </div>

                                    </HtmlTooltip>

                                </p>
                            </div>

                        )}
                    </>
                );
            }
        },

        {
            field: 'processedCounts',
            headerName: 'Processed Counts',
            minWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>

                        <>&nbsp;<strong>Valid Document Count: </strong>&nbsp;{params.row.validDocumentCount}</>

                        <><br />&nbsp;<strong>Created Document Count: </strong>&nbsp;{params.row.createdDocumentCount}</>

                        <><br />&nbsp;<strong>Original Document Count: </strong>&nbsp;{params.row.originalDocumentCount}</>

                        <><br />&nbsp;<strong>Uploaded Document Count: </strong>&nbsp;{params.row.uploadedDocumentCount}</>
                    </div>
                );
            }
        },
        {
            field: 'errorCounts',
            headerName: 'Error Counts',
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>

                        <>&nbsp;<strong>Invalid Document Count: </strong>&nbsp;{params.row.invalidDocumentCount}</>

                        <><br />&nbsp;<strong>Failed Created Document Count: </strong>&nbsp;{params.row.failedCreatedDocumentCount}</>

                        <><br />&nbsp;<strong>Failed Uploaded Document Count: </strong>&nbsp;{params.row.failedUploadedDocumentCount}</>

                    </div>
                );
            }
        },
        {
            field: 'exceptionMsg',
            headerName: 'Exception Message',
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                       {params.value}
                    </div>
                );
            }
        }
    ];

    // post process the columns to hide columns which typically don't have any data
    const generateColumns = (columns, jobData) => {

        let newColumns = [];

        columns.forEach((col) => {
            if (col.field === 'internalTrakingFiles') {
                let allInternalTrakingFiles = jobData.filter((job) => job.internalTrakingFiles.length);

                if (!allInternalTrakingFiles.length) {
                    col.hide = true;
                }
            } else if (col.field === 'emails') {
                let allEmails = jobData.filter((job) => job.emails.length);

                if (!allEmails.length) {
                    col.hide = true;
                }
            }

            // if all 3 values are empty, then hide column
            else if (col.field === 'documentFailurePaths') {
                let allInvalidDocumentPaths = jobData.filter((job) => job.invalidDocumentPaths.length);
                let allFailedCreatedDocumentPaths = jobData.filter((job) => job.failedCreatedDocumentPaths.length);
                let allFailedUploadedDocumentPaths = jobData.filter((job) => job.failedUploadedDocumentPaths.length);

                let combinedFailPath = [...allInvalidDocumentPaths, ...allFailedCreatedDocumentPaths, ...allFailedUploadedDocumentPaths];
                if (!combinedFailPath.length) {
                    col.hide = true;
                }
            }

            else if (col.field === 'trkFiles') {
                let allTRKFiles = jobData.filter((job) => job.trkFiles.length);

                if (!allTRKFiles.length) {
                    col.hide = true;
                }
            } else if (col.field === 'metadataFiles') {
                let allMetadataFiles = jobData.filter((job) => job.metadataFiles.length);

                if (!allMetadataFiles.length) {
                    col.hide = true;
                }
            }

            newColumns.push(col);
        });

        return newColumns;
    };


    const handleJobDialogClose = (event, reason) => {
        if (reason && reason === "backdropClick") {
            return;
        }
        onClose();
    };


    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setOpenView(true);
    };

    const handleClose = () => {
        setOpenView(false);
    };

    const columnsValueBased = generateColumns(columns, jobData);

    const title = `Ingestion Job Status`;
    const buttonText = `Close`;

    return (

        <>
            <Dialog onClose={handleJobDialogClose} open={open} maxWidth={'lg'} fullWidth={true}
            PaperProps={{
                sx: {
                    maxWidth: '100%',
                    maxHeight: 545
                }
            }}>
                <DialogTitle>
                    <div>{title}</div>
                    {onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                <DialogContent dividers={true}>

                    <div id="ingestionJobStatusTableContainer" style={{ marginTop: '10px'}}>
                        <div >
                            <Table data={jobData} columns={columnsValueBased} hiddenColumns={generateHiddenColumns(columnsValueBased)} viewRowData={viewRowData} />
                        </div>
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained"
                        sx={{
                            color: '#333330',
                            backgroundColor: '#82C027',
                            boxShadow: '0px 1px 2px #6F7687',
                            borderRadius: '5px',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#82C027',
                                boxShadow: 'none'
                            }
                        }}
                        onClick={handleJobDialogClose}>{buttonText}</Button>
                </DialogActions>

            </Dialog >

            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={openView}
                mode={mode}
                onClose={handleClose}
                title="Ingestion Job Status Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'ingestionJobStatusDialogId'}
                        readOnly={true}
                        schema={ingestionJobStatusSchemaView}
                        uiSchema={uiSchema}
                        formData={rowJsonData}
                    />
                }
                jsonDataName="ingestion job status"
                JSONTabContent={rowJsonData}
            />

        </>
    );
}


export default IngestionJobDialog;